/* eslint-disable */
import config from '../../../config';

const analyticsEnv = config.segment.analyticsEnv; // dev || prod
// @ts-expect-error TS(1345): An expression of type 'void' cannot be tested for ... Remove this comment to see the full error message
!(function () {
    // @ts-expect-error TS(2339): Property 'analytics' does not exist on type 'Windo... Remove this comment to see the full error message
    const analytics = (window.analytics = window.analytics || []);
    if (!analytics.initialize)
        if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.');
        else {
            analytics.invoked = !0;
            analytics.methods = [
                'trackSubmit',
                'trackClick',
                'trackLink',
                'trackForm',
                'pageview',
                'identify',
                'reset',
                'group',
                'track',
                'ready',
                'alias',
                'debug',
                'page',
                'once',
                'off',
                'on',
                'addSourceMiddleware',
                'addIntegrationMiddleware',
                'setAnonymousId',
                'addDestinationMiddleware'
            ];
            analytics.factory = function (e: $TSFixMe) {
                return function () {
                    const t = Array.prototype.slice.call(arguments);
                    t.unshift(e);
                    analytics.push(t);
                    return analytics;
                };
            };
            for (let e = 0; e < analytics.methods.length; e++) {
                const key = analytics.methods[e];
                analytics[key] = analytics.factory(key);
            }
            analytics.load = function (key: $TSFixMe, e: $TSFixMe) {
                const t = document.createElement('script');
                t.type = 'text/javascript';
                t.async = !0;
                t.src = `https://analytics.stackbit.com//analytics.${analyticsEnv}.js`;
                const n = document.getElementsByTagName('script')[0];
                // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                n.parentNode.insertBefore(t, n);
                analytics._loadOptions = e;
            };
            analytics._writeKey = config.segment.writeKey;
            analytics.SNIPPET_VERSION = '4.15.3';
            analytics.load(config.segment.writeKey);
        }
})();
